<template>
  <div class="nav-bg">
    <div class="nav-tank">
      <div class="logo">
        <a href="http://inspiringhk.org/#/"
          ><img src="../assets/logo.png" alt
        /></a>
      </div>
      <div class="nav-bar">
        <div @click="mainToggle" class="main-btn">
          <svg
            t="1591433855407"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2628"
            width="200"
            height="200"
          >
            <path
              d="M905.848832 706.56c22.84544 0 41.744384 18.75968 41.744384 41.603072 0 23.6032-18.898944 42.364928-41.744384 42.364928L301.010944 790.528c-22.833152 0-41.728-18.75968-41.728-42.364928 0-22.843392 18.896896-41.603072 41.728-41.603072L905.848832 706.56zM139.56096 215.488512c29.927424 0 53.557248 24.406016 53.557248 53.54496 0 29.927424-23.631872 53.559296-53.557248 53.559296C110.422016 322.592768 86.016 298.960896 86.016 269.033472 86.016 239.894528 110.422016 215.488512 139.56096 215.488512L139.56096 215.488512zM301.010944 317.44c-22.833152 0-41.728-19.13856-41.728-41.984s18.896896-41.984 41.728-41.984l604.837888 0c22.84544 0 41.744384 19.13856 41.744384 41.984s-18.898944 41.984-41.744384 41.984L301.010944 317.44zM301.010944 569.344c-22.833152 0-41.728-19.140608-41.728-41.984s18.896896-41.984 41.728-41.984l604.837888 0c22.84544 0 41.744384 19.140608 41.744384 41.984s-18.898944 41.984-41.744384 41.984L301.010944 569.344zM139.56096 458.835968c29.927424 0 53.557248 23.63392 53.557248 53.557248 0 29.140992-23.631872 53.557248-53.557248 53.557248C110.422016 565.950464 86.016 541.534208 86.016 512.393216 86.016 482.46784 110.422016 458.835968 139.56096 458.835968L139.56096 458.835968zM139.56096 701.407232c29.927424 0 53.557248 24.420352 53.557248 53.559296 0 29.925376-23.631872 53.54496-53.557248 53.54496C110.422016 808.511488 86.016 784.893952 86.016 754.968576 86.016 725.827584 110.422016 701.407232 139.56096 701.407232L139.56096 701.407232z"
              p-id="2629"
            />
          </svg>
        </div>
        <ul class="fir-ul" ref="mainlist">
          <li
            class="nav-item"
            :class="selectNav === item.NavItemName ? 'active' : ''"
            v-for="(item, index) in navList"
            :key="index"
            @click="changePage(index)"
          >
            {{ $t("nav." + item.NavItemName) }}
            <ul class="sec-menu" v-show="item.NavChild.length">
              <li
                @click.stop="changePage(item1)"
                v-for="(item1, index1) in item.NavChild"
                :key="index1"
              >
                {{
                  $t("msg.hello") === "hello"
                    ? item1.scholarship_child1_en
                    : item1.scholarship_child1
                }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from "vue";
export default {
  data() {
    return {
      navList: [
        {
          NavItemName: "home",
          NavItemUrl: "/",
          NavChild: [],
        },
        {
          NavItemName: "plan",
          NavItemUrl: "overview",
          NavChild: [],
        },
        {
          NavItemName: "scholarship",
          NavItemUrl: "fundapplication",
          NavChild: [
            {
              parentNav: 2,
              scholarship_child1: "立即申請",
              scholarship_child_url: "fundapplication",
              scholarship_child1_en: "Scholarship Application",
            },
            {
              parentNav: 2,
              scholarship_child1: "坊間體育課程參考名單",
              scholarship_child_url: "externalsportsprogrammes",
              scholarship_child1_en:
                "Reference List of External Sports Programmes",
            },
            {
              parentNav: 2,
              scholarship_child1: "遞交報告",
              scholarship_child_url: "awardees",
              scholarship_child1_en:
                "Report Submission",
            },
          ],
        },
        {
          NavItemName: "q_a",
          NavItemUrl: "faq",
          NavChild: [],
        },
        {
          NavItemName: "donate",
          NavItemUrl: "supportingpartners",
          NavChild: [],
        },
      ],
      selectNav: "home",
      mainIsSshow: false,
    };
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    changePage(index) {
      if (isNaN(index)) {
        this.resetSetItem("selectNav", index.parentNav);
        this.$router.push({ path: index.scholarship_child_url });
        this.selectNav = localStorage.getItem("selectNav");
        this.$refs.mainlist.style.height = "0";
        if (this.isMobile()) {
          this.$refs.mainlist.style.height = "0";
          this.$refs.mainlist.style.overflow = "hidden";
        }
        return;
      }
      if (index === 2) {
        return;
      }
      // 设置sessionStroage
      this.resetSetItem("selectNav", this.navList[index].NavItemName);
      this.$router.push({ path: this.navList[index].NavItemUrl });
      this.selectNav = localStorage.getItem("selectNav");
      this.$refs.mainlist.style.height = "0";
    },
    // 移动端菜单显示/隐藏
    mainToggle() {
      if (this.$refs.mainlist.offsetHeight > 0) {
        this.$refs.mainlist.style.height = "0";
        this.$refs.mainlist.style.overflow = "hidden";
      } else {
        this.$refs.mainlist.style.height = "auto";
        this.$refs.mainlist.style.overflow = "unset";
      }
    },
    // 给当前选定页面重新赋值
    clockRoute() {
      // 判断是否第一次存储路由
      if (localStorage.getItem("selectNav") === null) {
        this.resetSetItem("selectNav", "home");
      }
      this.selectNav = localStorage.getItem("selectNav");
    },
  },
  created() {
    // 页面加载时重新赋值上一次点击的路由
    this.clockRoute();
  },
  mounted() {
    window.addEventListener("setItem", () => {
      this.selectNav = localStorage.getItem("selectNav");
    });
  },
};
</script>

<style lang="scss" scoped>
.nav-bg {
  width: 100%;
  z-index: 2;
  position: relative;
  background: #fff;
}
.nav-tank {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .logo {
    img {
      width: 90%;
      cursor: pointer;
    }
  }
  .nav-bar {
    width: 60%;
    cursor: pointer;
    font-size: 14px;
    height: 100%;
    .main-btn {
      display: none;
    }
    .fir-ul {
      height: 0;
      display: flex;
      justify-content: space-around;
      .nav-item {
        position: relative;
        height: 30px;
        &:hover .sec-menu {
          display: block;
        }
        .sec-menu {
          position: absolute;
          left: -5px;
          top: 30px;
          background: #2090c4;
          width: 260px;
          text-align: left;
          padding-top: 20px;
          padding-bottom: 20px;
          display: none;
          &:hover {
            display: block;
          }
          & > li {
            margin-left: 0.6vw;
            color: white;
            margin-bottom: 1.4vw;
          }
        }
      }
    }
    .active {
      color: #85c358;
    }
  }
  @media screen and (max-width: 768px) {
    .logo {
      & > img {
        width: 50%;
      }
    }
    .nav-bar {
      width: auto;
      font-size: 3vw;
      position: relative;
      margin-right: 12.5vw;
      & svg {
        width: 8vw;
        height: 8vw;
      }
      .main-btn {
        display: block;
      }
      .fir-ul {
        display: inline-block;
        // overflow: hidden;
        position: absolute;
        left: -45px;
        top: 8vw;
        background: white;
        width: 40%;
        text-indent: auto;
        transition: all ease-in-out 0.3s;
        border-radius: 0 0 10px 10px;
        width: 32vw;
        height: 0;
        text-align: center;
        .nav-item {
          width: 100%;
          line-height: 10vw;
          border-bottom: solid 1px #ccc;
          height: auto;
          .sec-menu {
            left: -150px;
            top: -50px;
            width: 150px;
            &:hover {
              display: block;
            }
            & > li {
              margin-left: 0.6vw;
              color: white;
              margin-bottom: 1.4vw;
            }
          }
        }
      }
    }
  }
}
</style>
